module.exports = __webpack_public_path__ + "img/credit-cards-up.907d2173.svg";